import { gql } from '@apollo/client';

// Query to get all custom field schemas for a team
export const GET_TEAM_CONTACT_FIELD_SCHEMAS = gql`
  query GetTeamContactFieldSchemas($teamId: ID!) {
    teamContactFieldSchemas(teamId: $teamId) {
      id
      fieldKey
      fieldLabel
      fieldType
      displayOrder
      inUse
      usageCount
      createdAt
      updatedAt
    }
  }
`;

// Mutation to create a new custom field schema
export const CREATE_TEAM_CONTACT_FIELD_SCHEMA = gql`
  mutation CreateTeamContactFieldSchema(
    $teamId: ID!
    $fieldLabel: String!
    $fieldType: String
  ) {
    createTeamContactFieldSchema(
      teamId: $teamId
      fieldLabel: $fieldLabel
      fieldType: $fieldType
    ) {
      teamContactFieldSchema {
        id
        fieldKey
        fieldLabel
        fieldType
        displayOrder
        inUse
        usageCount
      }
      errors
    }
  }
`;

// Mutation to update an existing custom field schema
export const UPDATE_TEAM_CONTACT_FIELD_SCHEMA = gql`
  mutation UpdateTeamContactFieldSchema(
    $id: ID!
    $fieldLabel: String
    $fieldType: String
  ) {
    updateTeamContactFieldSchema(
      id: $id
      fieldLabel: $fieldLabel
      fieldType: $fieldType
    ) {
      teamContactFieldSchema {
        id
        fieldKey
        fieldLabel
        fieldType
        displayOrder
        inUse
        usageCount
      }
      errors
    }
  }
`;

// Mutation to delete a custom field schema
export const DELETE_TEAM_CONTACT_FIELD_SCHEMA = gql`
  mutation DeleteTeamContactFieldSchema($id: ID!) {
    deleteTeamContactFieldSchema(id: $id) {
      success
      message
    }
  }
`;

// Mutation to reorder custom field schemas
export const REORDER_TEAM_CONTACT_FIELD_SCHEMAS = gql`
  mutation ReorderTeamContactFieldSchemas($teamId: ID!, $orderedIds: [ID!]!) {
    reorderTeamContactFieldSchemas(teamId: $teamId, orderedIds: $orderedIds) {
      teamContactFieldSchemas {
        id
        fieldKey
        fieldLabel
        displayOrder
      }
      errors
    }
  }
`;
